var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spin-b" }, [
      _c("div", { staticClass: "spin-b1" }),
      _vm._v(" "),
      _c("div", { staticClass: "spin-b2" }),
      _vm._v(" "),
      _c("div", { staticClass: "spin-b3" }),
      _vm._v(" "),
      _c("div", { staticClass: "spin-b4" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }